<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     工位选择器
  | @author:    xander
  +---------------------------------------------------------------------------------------
-->
<template>
  <el-select v-model="stationid" :placeholder="placeholder" popper-class="multi" filterable clearable @change="selectChange" style="width: 100%">
    <el-option v-for="(item, index) in stations" :key="index" :label="item.station_no + ' / ' + item.station_title" :value="item.stationid">
      <div class="item-top text-muted" style="font-size: 12px">{{ item.station_no }}</div>
      <div class="item-bottom">{{ item.station_title }}</div>
    </el-option>
  </el-select>
</template>

<script>
import { getStationDataApi } from '@/api/pp/stationApi'

export default {
  name: 'PpStationSelector',

  props: {
    value: {
      type: [Number, String],
      default: 0
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
  },

  data() {
    return {
      stations: []
    }
  },

  computed: {
    stationid: {
      get() {
        return this.value ? this.value : null
      },
      set(val) {
        this.$emit('input', val ? val : null)
      }
    }
  },

  created() {
    this.fetchData()
  },

  methods: {
    fetchData() {
      getStationDataApi().then(res => {
        if (!res.errno) {
          this.stations = res.data
        }
      })
    },

    selectChange(val) {
      const list = this.stations.map(v => v.stationid)
      const index = list.indexOf(val)
      const item = this.stations[index]
      this.$emit('change', item)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>